import { GridBlockType } from 'services/entities/BlockTypes';
import { useSelector } from 'react-redux';
import { EditorDefaultSidePanelType } from '../../grid/reduxStore/blockStyleSettingsSlice.ts';
import type { RootState } from '../../grid/reduxStore/Store';
import { SecondaryMenuWrapper } from '../component';
import { Uploads } from '../Uploads/index.tsx';
import { DefaultStyleSettings } from './DefaultStyleSettings/index';
import { TextSnippetsPanel } from './LibrarySettings/TextSnippetsPanel.tsx';
import { ColumnSettings, FooterRowSettings, RowSettings, TableDefaultSettings } from './TableSettings';
import { TableDefaultStyleSettings } from './TableSettings/TableDefaultStyleSettings';
import { TableSettingsTypes } from './TableSettings/types';
import { ImageBlockWithUndoRedoSettings } from './DesignSettings/ImageBlock/ImageBlockWithUndoRedoSettings.tsx';
import { TextWithUndoRedoBlockSettings } from './DesignSettings/Textblock/TextWithUndoRedoBlockSettings.tsx';
import { ShapeWithUndoRedoBlockSettings } from './DesignSettings/ShapeBlock/ShapeWithUndoRedoBlockSettings.tsx';
import { VideoWithUndoRedoBlockSettings } from './DesignSettings/VideoBlock/VideoWithUndoRedoBlockSettings.tsx';
import { EmbedWithUndoRedoBlockSettings } from './DesignSettings/EmbedBlock/EmbedWithUndoRedoBlockSettings.tsx';
import { AdvancedSpacingWithUndoRedo } from './DesignSettings/AdvancedSpacing/AdvancedSpacingWithUndoRedo.tsx';

const panelMapping = {
  [TableSettingsTypes.TABLE_ROWS]: RowSettings,
  [TableSettingsTypes.TABLE_COLUMNS]: ColumnSettings,
  [TableSettingsTypes.TABLE_FOOTER_ROWS]: FooterRowSettings,
  [TableSettingsTypes.TABLE_DEFAULTS]: TableDefaultSettings,
  [EditorDefaultSidePanelType.DEFAULT_STYLE_SETTINGS_PANEL]: DefaultStyleSettings,
  [EditorDefaultSidePanelType.TABLE_DEFAULT_STYLE_SETTINGS_PANEL]: TableDefaultStyleSettings,
  [EditorDefaultSidePanelType.TEXT_SNIPPET_LIBRARY_PANEL]: TextSnippetsPanel,
  [EditorDefaultSidePanelType.UPLOADS_LIBRARY_PANEL]: Uploads,
} as const;

export default function SidePanelModels() {
  const { activeSidePanel, isAdvancedSpacingModelOpen } = useSelector((state: RootState) => state.blockStyleSettings);

  let ModelToRender;

  if (isAdvancedSpacingModelOpen) {
    ModelToRender = AdvancedSpacingWithUndoRedo;
  } else if (activeSidePanel === GridBlockType.IMAGE) {
    ModelToRender = ImageBlockWithUndoRedoSettings;
  } else if (activeSidePanel === GridBlockType.TEXT) {
    ModelToRender = TextWithUndoRedoBlockSettings;
  } else if (activeSidePanel === GridBlockType.SHAPE) {
    ModelToRender = ShapeWithUndoRedoBlockSettings;
  } else if (activeSidePanel === GridBlockType.VIDEO) {
    ModelToRender = VideoWithUndoRedoBlockSettings;
  } else if (activeSidePanel === GridBlockType.EMBED) {
    ModelToRender = EmbedWithUndoRedoBlockSettings;
  } else if (
    [TableSettingsTypes.TABLE_ROWS, TableSettingsTypes.TABLE_COLUMNS, TableSettingsTypes.TABLE_FOOTER_ROWS].includes(
      activeSidePanel as TableSettingsTypes
    )
  ) {
    ModelToRender = panelMapping[TableSettingsTypes.TABLE_DEFAULTS];
  } else {
    ModelToRender = panelMapping[activeSidePanel as keyof typeof panelMapping];
  }

  return ModelToRender ? (
    <SecondaryMenuWrapper>
      <ModelToRender />
    </SecondaryMenuWrapper>
  ) : null;
}
